import { render, staticRenderFns } from "./VideoDetail.vue?vue&type=template&id=18ab3080&scoped=true"
import script from "./VideoDetail.vue?vue&type=script&lang=js"
export * from "./VideoDetail.vue?vue&type=script&lang=js"
import style0 from "./VideoDetail.vue?vue&type=style&index=0&id=18ab3080&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ab3080",
  null
  
)

export default component.exports